import { createTheme, ThemeProvider } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { withLayout } from '../../Layout/Layout';
import { LandingPage } from '../../components/LandingPage/LandingPage';
import { httpGet } from '../../utils/httpClient';
import { useSelector } from 'react-redux';

const theme = createTheme({
  palette: {
    primary: {
      main: '#00454A',
    },
    secondary: {
      main: '#202020',
    },
  },
  typography: {
    fontFamily: '"Libre Franklin", sans-serif',
  },
});
export const getStaticPaths = async () => {
  return {
    paths: [],
    fallback: 'blocking',
  };
};
export const getStaticProps = async ({ params }) => {
  const cabinClass = params.all[1] ? params.all[0] : null;
  const destination = params.all[1] ? params.all[1] : params.all[0];
  const landingRes = await httpGet(
    `${process.env.javaApiUrl}/landing?textIdDirection=${destination}${
      cabinClass ? '&textIdClass=' + cabinClass : ''
    }`
  );

  if (landingRes.status >= 400) {
    return {
      notFound: true,
      revalidate: 60,
    };
  }
  const landing = await landingRes.json();
  const recommendationRes = await httpGet(
    `${process.env.javaApiUrl}/recommendation`
  );
  const arrival = landing.cityTo || landing.countryTo || landing.regionTo;
  const recommendation = await recommendationRes.json();
  const yrLocationRes = await httpGet(
    `https://www.yr.no/api/v0/locations/suggest?language=en&q=${arrival.name}`
  );
  const yrLocation = await yrLocationRes.json();
  const yrLocationMeta = yrLocation._embedded;
  const location =
    yrLocationMeta?.location?.find((location) =>
      arrival.name?.includes(location.name.includes)
    ) || yrLocationMeta?.location[0];
  const yrLocationId = location?.id;
  const yrWeatherWidgetURL = yrLocationId
    ? `https://www.yr.no/en/content/${yrLocationId}/table.html`
    : null;

  return {
    props: {
      landing,
      cabinClass,
      destination,
      yrWeatherWidgetURL,
      recommendation,
      selfUrl: params.all,
    },
    revalidate: 60,
  };
};

function FlightLanding({
  landing,
  // eslint-disable-next-line no-unused-vars
  destination,
  authCompleted,
  recommendation,
  yrWeatherWidgetURL,
  selfUrl,
}) {
  const userStore = useSelector((state) => state.user.value);
  const [currency, setCurrency] = useState(null);
  const arrival = landing.cityTo || landing.coountryTo || landing.regionTo;
  useEffect(() => {
    if (userStore && arrival) {
      if (userStore.currency !== arrival.currency) {
        httpGet(
          `/api/flight/currency?from=${userStore.currency}&to=${arrival.currency}`
        ).then((res) => {
          res.json().then((currency) => {
            setCurrency(currency);
          });
        });
      }
    }
  }, [userStore]);

  return (
    <ThemeProvider theme={theme}>
      <LandingPage
        landing={landing}
        authCompleted={authCompleted}
        recommendation={recommendation}
        yrWeatherWidgetURL={yrWeatherWidgetURL}
        currency={currency}
        selfUrl={selfUrl}
      />
    </ThemeProvider>
  );
}

export default withLayout(FlightLanding, false);
